import { PREDICT_PRODUCT_SLUG } from '@futrli/shared-services';
import { BASE_COLORS } from '../core/colors';

export const getColorsByProduct = (product: string) => {
  switch (product) {
    case PREDICT_PRODUCT_SLUG: {
      return {
        color: BASE_COLORS.mint,
        gradientColor: BASE_COLORS.mint
      };
    }
    default: {
      return {
        color: BASE_COLORS.red,
        gradientColor: BASE_COLORS.pink
      };
    }
  }
};
